var map = {
	"./bg.json": [
		"./static/l10n/common/bg.json",
		"static_l10n_common_bg_json"
	],
	"./da.json": [
		"./static/l10n/common/da.json",
		"static_l10n_common_da_json"
	],
	"./de.json": [
		"./static/l10n/common/de.json",
		"static_l10n_common_de_json"
	],
	"./el.json": [
		"./static/l10n/common/el.json",
		"static_l10n_common_el_json"
	],
	"./en-SOCIAL.json": [
		"./static/l10n/common/en-SOCIAL.json",
		"static_l10n_common_en-SOCIAL_json"
	],
	"./en.json": [
		"./static/l10n/common/en.json",
		"static_l10n_common_en_json"
	],
	"./es.json": [
		"./static/l10n/common/es.json",
		"static_l10n_common_es_json"
	],
	"./fi.json": [
		"./static/l10n/common/fi.json",
		"static_l10n_common_fi_json"
	],
	"./fr-CA.json": [
		"./static/l10n/common/fr-CA.json",
		"static_l10n_common_fr-CA_json"
	],
	"./fr.json": [
		"./static/l10n/common/fr.json",
		"static_l10n_common_fr_json"
	],
	"./id.json": [
		"./static/l10n/common/id.json",
		"static_l10n_common_id_json"
	],
	"./it.json": [
		"./static/l10n/common/it.json",
		"static_l10n_common_it_json"
	],
	"./ja.json": [
		"./static/l10n/common/ja.json",
		"static_l10n_common_ja_json"
	],
	"./ko.json": [
		"./static/l10n/common/ko.json",
		"static_l10n_common_ko_json"
	],
	"./nl.json": [
		"./static/l10n/common/nl.json",
		"static_l10n_common_nl_json"
	],
	"./nn.json": [
		"./static/l10n/common/nn.json",
		"static_l10n_common_nn_json"
	],
	"./pl.json": [
		"./static/l10n/common/pl.json",
		"static_l10n_common_pl_json"
	],
	"./pt-BR.json": [
		"./static/l10n/common/pt-BR.json",
		"static_l10n_common_pt-BR_json"
	],
	"./pt.json": [
		"./static/l10n/common/pt.json",
		"static_l10n_common_pt_json"
	],
	"./ro.json": [
		"./static/l10n/common/ro.json",
		"static_l10n_common_ro_json"
	],
	"./ru.json": [
		"./static/l10n/common/ru.json",
		"static_l10n_common_ru_json"
	],
	"./sv.json": [
		"./static/l10n/common/sv.json",
		"static_l10n_common_sv_json"
	],
	"./th.json": [
		"./static/l10n/common/th.json",
		"static_l10n_common_th_json"
	],
	"./tr.json": [
		"./static/l10n/common/tr.json",
		"static_l10n_common_tr_json"
	],
	"./uk.json": [
		"./static/l10n/common/uk.json",
		"static_l10n_common_uk_json"
	],
	"./vi.json": [
		"./static/l10n/common/vi.json",
		"static_l10n_common_vi_json"
	],
	"./zh.json": [
		"./static/l10n/common/zh.json",
		"static_l10n_common_zh_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./static/l10n/common lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;